import React, { useEffect } from 'react'
import { Switch } from 'react-router-dom'

import Route from './Route'

import BemVindo from '../pages/BemVindo'
import Simulation from '../pages/Simulation'
import ResultSimulation from '../pages/ResultSimulation'
// import Seguro from '../pages/Seguro'
import ConfirmOwnership from '../pages/ConfirmOwnership'
import RespFinanc from '../pages/RespFinanc'
import FatcaInfo from '../pages/FatcaInfo'
import ParticipantsList from '../pages/ParticipantsList'
import Resume from '../pages/Resume'
import ConfirmSMS from '../pages/ConfirmSMS'
import End from '../pages/End'

import Erro from '../pages/Erro'
import NotFound from '../pages/NotFound'

import usePersistedState from '../hooks/usePersistedState'
import clientConfig from '../services/clientConfig'
import { ConfigData } from '../utils/interfaces'

const Routes: React.FC = () => {
  const { codCliente, tipo, plano } = clientConfig()

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  useEffect(() => {
    setConfigData({
      ...configData,
      codCliente,
      tipo,
      plano,
    })
  }, [])

  return (
    <Switch>
      <Route path="/" exact component={BemVindo} />
      <Route path="/simulation" component={Simulation} />
      <Route path="/result-simulation" component={ResultSimulation} />
      {/* <Route path="/seguro" component={Seguro} /> */}
      <Route path="/confirm-ownership" component={ConfirmOwnership} />
      <Route path="/responsavel" component={RespFinanc} />
      <Route path="/fatca" component={FatcaInfo} />
      <Route path="/participants-list" component={ParticipantsList} />
      <Route path="/resume" component={Resume} />
      <Route path="/confirm-sms" component={ConfirmSMS} />
      <Route path="/end" component={End} />

      <Route path="/erro" component={Erro} />
      <Route path="*" component={NotFound} />
    </Switch>
  )
}

export default Routes
